export default __webpack_public_path__ + "static/media/logo-brand.7c8ea0a5.png";